export const STATE_KEY: string = 'products'

